/**
 * 입력받을 문자열을 사업자번호 형식으로 변환해 반환하는 유틸함수
 * @example '123-45-67890'
 */

const formatBusinessNumber = (value: string): string => {
  let formattedBusinessNumber = '';

  const numbers = value.replace(/\D/g, '');

  const part1 = numbers.slice(0, 3);
  const part2 = numbers.slice(3, 5);
  const part3 = numbers.slice(5, 10);

  if (part3.length > 0) {
    formattedBusinessNumber = `${part1}-${part2}-${part3}`;
  } else if (part2.length > 0) {
    formattedBusinessNumber = `${part1}-${part2}`;
  } else {
    formattedBusinessNumber = part1;
  }

  return formattedBusinessNumber;
};

export default formatBusinessNumber;
